Revolution.Module.extend({
    NAME: "mde.show-popin", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/view-password.js)


    initialize: function ($) {
        //events
        if ($('.js-show-popin').length) {
            this.magnificPopup();
        }

        if ($('.js-show-img-popin').length) {
            this.showFullImg();
        }

        if ($('.js-show-video-popin').length) {
            this.showFullVideo();
        }
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },

    onWindowResize: function (e) {

    },

    magnificPopup: function () {
        $('.js-show-popin').magnificPopup({
            type: 'inline',
            preloader: false,
            focus: '#name',

            callbacks: {
                beforeOpen: function() {
                    if($(window).width() < 500) {
                        this.st.focus = false;
                    } else {
                        this.st.focus = '#name';
                    }
                }
            }
        });

        $('.js-close-popup').on('click', function() {
            $(this).closest('.popin').find('.mfp-close').click();
        });
    },

    showFullImg : function() {
        $('.js-show-img-popin').magnificPopup({
            type: 'image',
            mainClass: '-popin-img'
        });
    },

    showFullVideo : function() {
        $('.js-show-video-popin.remote-video').magnificPopup({
            type: 'iframe',
            mainClass: '-popin-video'
        });

        $('.js-show-video-popin.internal-video').magnificPopup({
            type: 'iframe',
            mainClass: '-popin-video',
            iframe: {
                markup: '<div class="bk-video-wrapper">'+
                              '<div class="mfp-close"></div>'+
                              '<video src="" controls></video>'+
                            '</div>',
            },
            callbacks: {
                open: function() {
                    $('.mfp-content video').attr('src', this.currItem.src);
                    var MAIN = Revolution.get("mde.main");
                    MAIN.playerVideo();
                }
            }
        });
    }
});
